// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rating[data-v-428e3c42] .vue-star-rating-rating-text {\n  padding-top: 0.375rem;\n  font-size: 0.875rem;\n}", ""]);
// Exports
module.exports = exports;
